var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeStrikethrough(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 82 82",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41,17.1c7.6,0,14.2,2.3,20,6.9c5.8,4.5,9.7,10.3,11.8,17c-1.1,3.6-2.8,7-5.3,9.8l5.7,5.7c3.8-4.5,6.5-9.8,7.9-15.4 c-2.2-9.1-7.6-17.4-15-23.2C58.9,12.1,50,9.1,41,9.1c-4.4,0-8.8,0.8-12.8,2.4l6.9,6.9C36.9,17.5,38.9,17.1,41,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,39.2c0.5-6.7-6.1-14-13.3-13.3L56,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,62.4C68,62.4,68,62.4,68,62.4l-5.6-5.6L39.2,33.6l-6.3-6.3h0l-6.7-6.7h0l-5.9-5.9L7.9,2.3C4.3-1.3-1.5,4.1,2.3,7.9 l11.6,11.6C7.5,25.2,2.9,32.8,1,41C3.1,50,8.5,58.4,15.9,64.2c7.1,5.7,15.9,8.7,25,8.7c7.7,0,14.9-2.4,20.6-5.7L74,79.6 c3.9,3.8,9.2-2,5.6-5.6L68,62.4z M43,48.6c-0.7,0.1-1.3,0.3-2.1,0.3c-4.9,0-8-3.1-8-8c0-0.8,0.2-1.4,0.3-2.1L43,48.6z M41,64.9 c-7.5,0-14.2-2.3-20-6.9c-5.8-4.6-9.7-10.3-11.7-17c1.8-6.2,5.3-11.5,10.3-15.8l7.7,7.7C25.8,35.2,25,38,25,41 c0,8.8,7.2,15.9,15.9,15.9c2.9,0,5.7-0.8,8.1-2.3l6.6,6.6C50.8,63.8,46.1,64.9,41,64.9z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeStrikethrough);
export default __webpack_public_path__ + "static/media/eye_strikethrough.f66ce3ae.svg";
export { ForwardRef as ReactComponent };